module.exports = __webpack_public_path__ + "img/logo_hesso.c44ee5c6.jpg";